// ** Type Import
import type { OwnerStateThemeType } from '.';

// .MuiButtonBase-root.MuiMenuItem-root .MuiListItemIcon-root
const List = () => {
  return {
    MuiListItemIcon: {
      styleOverrides: {
        root: ({ theme }: OwnerStateThemeType) => ({
          width: '25px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginRight: theme.spacing(4),
          color: theme.palette.text.secondary,
        }),
      },
    },
    MuiListItemAvatar: {
      styleOverrides: {
        root: ({ theme }: OwnerStateThemeType) => ({
          minWidth: 0,
          marginRight: theme.spacing(4),
        }),
      },
    },
    MuiListItemText: {
      styleOverrides: {
        dense: ({ theme }: OwnerStateThemeType) => ({
          '& .MuiListItemText-primary': {
            color: theme.palette.text.primary,
          },
        }),
      },
    },
    MuiListSubheader: {
      styleOverrides: {
        root: ({ theme }: OwnerStateThemeType) => ({
          height: '24px',
          lineHeight: '24px',
          fontWeight: 600,
          textTransform: 'uppercase',
          color: theme.palette.text.secondary,
          borderTop: `0.5px solid ${theme.palette.divider}`,
          backgroundColor: theme.palette.background.header,
          backdropFilter: theme.palette.background.filter,
        }),
      },
    },
  };
};

export default List;
